import { Component, Input } from '@angular/core';
import { KATEX_FORMAT } from '@app/app.constants';
import { AFormat, Character } from '@df/interfaces';
import { IExercise } from '@df/interfaces/exercise';
import { NEW_LINE_KATEX } from '@pipes/exercise-format.pipe';

@Component({
    selector: 'app-exercise-preview-task',
    templateUrl: './exercise-preview-task.component.html',
    styleUrls: ['../../../../_pipes/exercise-format.pipe.scss', './exercise-preview-task.component.scss']
})
export class ExercisePreviewTaskComponent {
    @Input() exercise: IExercise;
    @Input() character: Character;
    @Input() index: number;
    @Input() card_format: string;
    @Input() mainCardView = false;

    x = 0;

    constructor() {}

    getWidth(card_format) {
        if (this.character) {
            if (card_format === AFormat.A6_FORMAT) {
                return '70%';
            }
            if (card_format === AFormat.A7_FORMAT) {
                return '65%';
            }
            if (card_format === AFormat.A3_FORMAT) {
                return '85%';
            }
            if (card_format === AFormat.A5_FORMAT) {
                return '50%';
            }
        }
        return '100%';
    }

    getFont(format: string) {
        let fs = '7px';
        switch (format) {
            case AFormat.A7_FORMAT:
                fs = '7px';
                break;
            case AFormat.A5_FORMAT:
                fs = '5px';
                break;
            case AFormat.A3_FORMAT:
                fs = '8px';
                break;
        }
        return fs;
    }

    get getText(): string {
        if (!this.exercise) {
            return '';
        }
        return (
            this.exercise.text +
            NEW_LINE_KATEX +
            (this.exercise.questions || []).map(({ text }) => text || '').join(NEW_LINE_KATEX)
        );
    }

    isKatexFormat(exercise: IExercise): boolean {
        return exercise.format_type === KATEX_FORMAT;
    }

    getQuestionsText(exercise: IExercise): string {
        return (exercise.questions || []).map(({ text }) => text || '').join(NEW_LINE_KATEX);
    }
}
